var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0, 0, 400,400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M181.905 38.313 C 45.185 54.267,-11.785 221.151,86.835 316.805 C 172.012 399.421,314.412 365.806,353.505 253.856 C 392.911 141.005,300.167 24.512,181.905 38.313 M223.828 65.189 C 305.547 80.079,355.665 163.614,329.989 242.131 C 298.089 339.680,175.988 368.991,103.499 296.501 C 22.683 215.685,69.480 79.889,183.594 64.083 C 191.231 63.025,215.637 63.696,223.828 65.189 M187.891 119.255 C 166.243 122.742,146.875 141.740,146.875 159.488 C 146.875 174.843,167.440 177.078,172.340 162.256 C 179.042 141.985,207.778 137.938,218.036 155.822 C 223.299 164.998,221.470 169.291,205.240 185.852 C 187.561 203.891,183.796 210.603,182.993 225.517 C 181.766 248.274,206.914 251.105,208.685 228.409 C 209.397 219.276,211.282 216.310,224.773 203.098 C 242.509 185.729,245.644 179.809,245.655 163.672 C 245.674 135.365,218.343 114.350,187.891 119.255 M190.234 256.528 C 177.852 262.261,182.032 280.804,195.707 280.804 C 212.085 280.804,213.046 256.805,196.712 255.718 C 194.259 255.555,191.625 255.884,190.234 256.528 ",
    stroke: "none",
    fill: "current",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c062b5c8ec094c6469e2fc3e7477b618.svg";
export { ForwardRef as ReactComponent };